import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createSpiritualAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface SpiritualAssessmentResult {
  id: string;
  assessmentType: 'fasdl' | 'facit-sp-12';
  scores: {
    overall: number;
    subscales?: {
      connectedness?: number;
      mindfulness?: number;
      compassion?: number;
      gratitude?: number;
      innerPeace?: number;
      spiritualWellBeing?: number;
    };
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
  };
  createdAt: string;
  // Also support nested structure for compatibility
  assessmentData?: {
    scores: {
      overall: number;
      subscales?: {
        connectedness?: number;
        mindfulness?: number;
        compassion?: number;
        gratitude?: number;
        innerPeace?: number;
        spiritualWellBeing?: number;
      };
    };
    results: {
      level: 'Low' | 'Moderate' | 'High';
      interpretation: string;
    };
  };
}

const SpiritualAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as SpiritualAssessmentResult;
  
  // Debug: Log the received data
  
  if (!assessmentResult) {
    // If no result data, redirect to insights
    navigate('/panel/learn/spiritual-resources');
    return null;
  }

  try {
    // Create configuration using the template system
    const config = createSpiritualAssessmentConfig(assessmentResult);
    
    // Use the template component
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/spiritual-resources');
    return null;
  }
};

export default SpiritualAssessmentCompletionPage;


